
import {Environment,EnvironmentEnum,SandboxEnvArr} from './env';

const Config = {
  Common:{
    ApiBaseUrl: "http://localhost:3035",
    ApiBaseSocket: "ws://localhost:3035",
    ApiSandboxBaseUrl: "http://localhost:3036",
    ApiSandboxBaseSocket: "ws://localhost:3036",
    AppName: "MythBlender",
    Company: "MythBlender",
    CdnUrl: "https://cdn.mythblender.com",
    CompanyLink: "https://mythblender.com/",
    FrontEndUrl: "http://localhost:3032",
    LiveFrontEndUrl: "http://localhost:3030",
    SandboxFrontEndUrl: "http://localhost:3031",
    SupportEmailName: "mail",
    SupportEmailDomain: "mythblender.com",
  },
  Keys:{
    StripePublicKey: "pk_test_51GqiwwCrETN7D82MGHEvNP7W4p9fULfvCpnEsMyVEBmW4yozC4dNt0kAkv2eiVCTkQiJ2O3sx1kmESXwNrZdLokE00ftcmpH3o",
    StripeAnnualPriceId: "price_1HCAeUCrETN7D82MEfWzgueZ",
    StripeMonthlyPriceId: "price_1HCAemCrETN7D82MVnoMy5J7",
    GoogleAnalytics: "",
    RecaptchaPubKey: "6Ld-yXYpAAAAAEM7_pBSm0LnIUdVk5lVt8eOhW6a",
  },
};

if(SandboxEnvArr.indexOf(Environment) !== -1){
  Config.Sandbox = true;
}

if(Environment === EnvironmentEnum.Release || Environment === EnvironmentEnum.ReleaseSandbox){
  Config.Common.LiveFrontEndUrl = "https://release.mythblender.com";
  Config.Common.ApiDocsUrl = "https://docs.mythblender.com";
  Config.Common.SandboxFrontEndUrl = "https://sandbox..com";
  Config.Keys.RecaptchaPubKey = "6Ld-yXYpAAAAAEM7_pBSm0LnIUdVk5lVt8eOhW6a";
}

if(Environment === EnvironmentEnum.Release){
  Config.Common.ApiBaseUrl = "https://release-api.mythblender.com";
  Config.Common.ApiBaseSocket = "wss://release-api.mythblender.com";
  Config.Common.FrontEndUrl = "https://release-admin.mythblender.com";
}

if(Environment === EnvironmentEnum.Production || Environment === EnvironmentEnum.ProductionSandbox){
  Config.Common.LiveFrontEndUrl = "https://mythblender.com";
  Config.Common.ApiDocsUrl = "https://docs.mythblender.com";
  Config.Common.SandboxFrontEndUrl = "https://sandbox..com";
  Config.Keys.RecaptchaPubKey = "6Ld-yXYpAAAAAEM7_pBSm0LnIUdVk5lVt8eOhW6a";
}

if(Environment === EnvironmentEnum.Production){
  Config.Common.ApiBaseUrl = "https://api.mythblender.com";
  Config.Common.ApiBaseSocket = "wss://api.mythblender.com";
  Config.Common.FrontEndUrl = "https://admin.mythblender.com";
}

if(Environment === EnvironmentEnum.ProductionSandbox){
  // Config.Common.ApiBaseUrl = "https://api.sanbox..com";
  // Config.Common.ApiBaseSocket = "wss://api.sanbox..com";
  // Config.Common.FrontEndUrl = Config.Common.SandboxFrontEndUrl;
}

export default Config;
